import { useEffect, useRef } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { onUpdate, offUpdate, CanonicalUserProfile } from '@updater/identity';
import { useEnvironment } from 'services/environment';
import { init as initDataDog } from './data-dog-rum';

export function Datadog({ children }) {
  const env = useEnvironment();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current && !window.Cypress) {
      hasInitialized.current = true;
      initDataDog(env);
    }
  }, [env]);

  useEffect(() => {
    const listener = (profile: CanonicalUserProfile) => {
      const { updUuid, displayName, ...rest } = profile;
      datadogRum.setUser({
        id: updUuid,
        name: displayName,
        ...rest,
      });
    };
    onUpdate(listener);
    return () => offUpdate(listener);
  }, []);

  return <>{children}</>;
}
